module.exports = __webpack_public_path__ + "img/img_brand32.836997b3.jpg";